export class AirHazardRequestDTO {
	streetAddress: string;
	city: string;
	state: string;
	zipCode: string;
	yearBuilt: string;
	public constructor(init?: Partial<AirHazardRequestDTO>) {
		Object.assign(this, init);
	}
}